import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from './rest_services/user.service';
import * as $ from 'jquery';
import { DashboardService } from './rest_services/dashboard.service';
import { MessageService } from './rest_services/msMessageServices/message.service';
import { VisitService } from './rest_services/visit.service';
import { CustomersService } from './rest_services/customers.service';
import { ScriptLoaderService } from './rest_services/script-loader.service';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { frontUrl, companyUrl } from './global_constants';
declare var NotificationFx:any;
declare var gtag:any;
//CURRENT VERSION v_sp_20_2025

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  companyUrl = companyUrl;
  title = 'wam_ng';
  logged:any;role:any;
  comp:any;signinpage:boolean=false;
  imagesource:any="";
  fullnameconnected:String="";
  roleconnected:any="";
  currentDate = new Date();
  landing_page:boolean=true;
  constructor(private router:Router,private userServiceService:UserService,private sanitizer: DomSanitizer, private customersService :CustomersService,
    private dashboardServiceservice:DashboardService, private messageService :MessageService, private visitService:VisitService,
    private scriptLoader: ScriptLoaderService) {
      router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updateSigninPageStatus(event.url);
        }
      });

      if(window.location.href.indexOf("index")==-1){
        this.user();
        this.landing_page = false;
      }
      const urlObject = new URL(window.location.href);
    
      // Vérifier si le pathname est vide ou juste '/'
      // Si le pathname est vide ou juste '/', alors il n'y a pas de slash supplémentaire après le domaine
    if(window.location.href.indexOf("index")>-1 || urlObject.pathname === '' || urlObject.pathname === '/'){
      this.loadStyle("assets/css/landing/cloud-bundle.min.css");
      this.loadScript("assets/js/app.js");
      this.landing_page = true;
    }
    const navEndEvents= router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    );
    navEndEvents.subscribe((event:any) => {
      gtag('config', environment.gtag.key, {
        'page_path':event.urlAfterRedirects
      });
    });
  }
  mobile:boolean=false;
  medium:boolean=false;
  showMenu:boolean=false;
  updateSigninPageStatus(url: string) {
    if (url.includes("signin")) {
      this.signinpage = true;
    } else {
      this.signinpage = false;
    }
  }
  public loadStyle(link:string) {
    let node = document.createElement("link");
    node.href = link;
    node.type = "text/javascript";
    node.id = "css_landing";
    node.rel ="stylesheet";
    var linksTags = document.getElementsByTagName('link');
    for (var i = linksTags.length; i--;) {
        if (linksTags[i].href != link) {
          document.getElementsByTagName("head")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  hideHeader: boolean = false;
  ngOnInit(): void {
    if(window.location.href.indexOf("index")==-1){
      // this.scriptLoader.loadScripts();
    }
    this.router.events.subscribe((val) => {
      if (this.router.url.includes('/satisfaction-survey') || this.router.url.includes('/wamgroup-satisfaction-survey')) {
        this.hideHeader = true;
      } else {
        this.hideHeader = false;
      }
    });
    if($('#theme_switcher_side').is(":checked")){
      $('#app').addClass("theme--light")
    }else {
      $('#app').removeClass("theme--light")
    }
    this.updateSigninPageStatus(window.location.href);
    // create the notification
    $(document).on('mouseup', function(e) {
      if (!$(e.target).closest('.menu').length) {
          $('.topMenu').hide();
      }
    });
  
    var bttn = document.getElementById( 'slide-on-top-notification' ) as any;
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    
    $(document).on('click', 'dropdown .dropdown-menu', function (e) {
      e.stopPropagation();
    });
    setTimeout(()=>{
      $('#eq-loader').hide();
      $(".scrollTop").click(function(){$("html, body").animate({scrollTop:0})});
    },1000);
    
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
      this.logged=localStorage.getItem("logged");
      this.comp=localStorage.getItem("comp");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.logged=sessionStorage.getItem("logged");
      this.comp=sessionStorage.getItem("comp");
    }

    if(window.location.href.indexOf("index")>-1){
      this.loadStyle("assets/css/landing/cloud-bundle.min.css");
      $("body").removeClass("public_back");
      setTimeout(()=>{
        let footer:any = document.getElementsByClassName("footer-section");          
        footer[0].style.display = "none";
      },2000);
    }else if((window.location.href.indexOf("signin")>-1 || window.location.href.indexOf("dashboard")>-1
      || window.location.href.indexOf("dash")>-1 || window.location.href.indexOf("dash-support")>-1
      || window.location.href.indexOf("mydash")>-1) && localStorage.getItem("token")!=null 
      && localStorage.getItem("token")!=undefined){      
        $("#css_landing").remove();
        if(this.role !== 'support')this.getVisitsToReplyNotif();
        this.loadScript("../assets/plugins/charts/sparklines/jquery.sparkline.min.js");
        this.loadScript("../assets/js/ui-kit/notification/tympanus/notificationFx.js");
        // Création d'un élément style
        const styleElement = document.createElement('style');
  
        // Définition des règles CSS
        styleElement.textContent = `
          /* Supprime tous les éléments qui pourraient suivre le curseur */
          [class*="cursor"], 
          [id*="cursor"], 
          [class*="mouse"], 
          [id*="mouse"],
          [class*="follow"],
          [id*="follow"] {
            display: none !important;
            opacity: 0 !important;
            pointer-events: none !important;
            visibility: hidden !important;
          }`;
        // Ajout du style au document
        document.head.appendChild(styleElement);
    }else {
      if((localStorage.getItem("token")==null && sessionStorage.getItem("token")==null) 
        || (localStorage.getItem("token")==undefined && sessionStorage.getItem("token")==undefined)
        || window.location.href.indexOf("index")>-1){
          $("body").removeClass("public_back");
          // window.location.href = '../index/';
      }
      else {
        if(window.location.href.indexOf("index")==-1 && window.location.href!=frontUrl){
          $("#css_landing").remove();
          $("body").removeClass("public_back");
          if(this.role !== 'support')this.getVisitsToReplyNotif();
        }
      }
    }
    var restPack:any = null;
     
    if(localStorage.getItem("pk")!=undefined && localStorage.getItem("pk")!=null) {
      var pk:any = localStorage.getItem("pk")?.split(/[\s-]+/)
      const rest_days = Number(pk[pk.length - 1]);
      restPack = rest_days;
    }
    if(sessionStorage.getItem("pk")!=undefined && sessionStorage.getItem("pk")!=null){
      var pk:any = sessionStorage.getItem("pk")?.split(/[\s-]+/)
      const rest_days = Number(pk[pk.length - 1]);
      
      restPack = rest_days;
    }   
    if(this.logged && this.role ==="adm" && restPack!=null && restPack<30){
      var lastDate:any = localStorage.getItem("trats_kp") ? localStorage.getItem("trats_kp") : !localStorage.getItem("trats_kp") ? sessionStorage.getItem("trats_kp"):null;
      var dateEndPack = new Date(lastDate);
      var today = new Date();
      lastDate = dateEndPack.setDate(dateEndPack.getDate()+7);
      var last:Date = new Date(lastDate);
      const options:any = {year: 'numeric', month: 'numeric', day: 'numeric' };
      var firstMessagePack = '<span class="icon-"></span><p>[Master Field] - Il vous reste : <span style="color:#ff7b01;">'+restPack+' jours</span>, pensez à renouveler votre abonnement</p>';
      var lastMessagePack = '<span class="icon-"></span><p>Vous ne pouvez plus utiliser votre espace, pensez à renouveler votre abonnement avant le : ';
      lastMessagePack = lastMessagePack +'<span style="color:yellow;">'+last.toLocaleDateString('fr-FR', options)+'</span></p>';
      var finalMessagePack = '<span class="icon-"></span><p>Vous ne pouvez plus utiliser votre espace, merci de contacter le service client Masterfield';
      $(".container").css("padding-top","45px !important");
      // if()
      setTimeout(()=>{
        if(this.logged && this.role ==="adm"){
          var x = document.getElementsByClassName('ns-box');
          var i;
          for (i = 0; i < x.length; i++) 
          {
            x[i].className += ' ns-type-director'; // WITH space added
          }
        }
        if(today>=last){
          $("header").css("filter","blur(2px)");
          $("div").css("filter","blur(2px)");
        }
      },1000);
      setTimeout(()=>{
        $(".ns-type-director").css("filter","blur(0px)");
        $(".ns-box-inner").css("filter","blur(0px)");
      },1800);
      var x = document.getElementsByClassName('ns-box');
      if(restPack<=0 && today<last){
        var notification = new NotificationFx({
          message : lastMessagePack,
          layout : 'bar',
          effect : 'slidetop',
          type : 'notice', // notice, warning or error
          onClose : function() {
              bttn.disabled = false;
          }
        });
        $("#ng-box").addClass("ns-type-director-warning");
        $(".ns-box-inner").css("color","black");
      }else if(restPack<=0 && today>=last){
        var notification = new NotificationFx({
          message : finalMessagePack,
          layout : 'bar',
          effect : 'slidetop',
          type : 'notice', // notice, warning or error
          onClose : function() {
              bttn.disabled = false;
          }
        });
        $("#ng-box").addClass("ns-type-director-danger");
      }else {
        var notification = new NotificationFx({
          message : firstMessagePack,
          layout : 'bar',
          effect : 'slidetop',
          type : 'notice', // notice, warning or error
          onClose : function() {
              bttn.disabled = false;
          }
        });
        $("#ng-box").addClass("ns-type-director-alert");
        $(".ns-box-inner").css("color","black");
      }
    }
  }
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  disconnect(){    
    this.logged=null;
    $(".ns-effect-bouncyflip").hide();
    // NotificationFx.prototype._initEvents = function() {
    //   var self = this;
    //   // dismiss notification
    //   this.ntf.querySelector( '.ns-close' ).addEventListener( 'click', function() { self.dismiss(); } );
    // }
    
    localStorage.removeItem("logged");
    sessionStorage.removeItem("logged");
    localStorage.removeItem("role");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("comp");
    localStorage.removeItem("comp");
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    localStorage.removeItem("fullname");
    sessionStorage.removeItem("fullname");
    sessionStorage.removeItem("msToken");
    localStorage.removeItem("msToken");
    sessionStorage.removeItem("userRoles");
    var restPack:any = null;
    localStorage.clear();
    sessionStorage.clear();
    // localStorage.setItem("pk_rest",restPack);
    // sessionStorage.setItem("pk_rest",restPack);
    window.location.href="/signin";
    this.router.navigate(['/signin']);
    setTimeout(()=>{
      $('#eq-loader').hide();
      $('.ns-type-director').hide();
      $("body").addClass("public_back");
    },1000);
    
  }
  logoCompany:any=null;
  connectedUser:any;
  loadingImages:boolean=true;
  connectedCompany:any=null;
  myPack:any=null;
  user(){
    this.userServiceService.getUserInfo();
    this.userServiceService.userSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f99fc2d2a6c1e8eb12bd88d1b0d05d26"){
          localStorage.setItem("visitDeadline",data.connected_user.visitDeadline);
          this.connectedUser = data.connected_user;
          this.loadingImages = false;
          this.connectedCompany = data.connected_user.company_name.toUpperCase();
          if(data.connected_user.user_avatar!=undefined && data.connected_user.user_avatar!=null){
            this.imagesource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/jpg;base64, `+data.connected_user.user_avatar);
          }else {
            this.imagesource = this.sanitizer.bypassSecurityTrustResourceUrl(`assets/img/unknown_user.jpg`);
          }
          if(data.connected_user.company_logo!=null && data.connected_user.company_logo!=undefined){
            this.logoCompany = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/jpg;base64, `+data.connected_user.company_logo);
          }
          localStorage.setItem("fullname",data.connected_user.user_fullname);
          sessionStorage.setItem("fullname",data.connected_user.user_fullname);
          this.fullnameconnected = data.connected_user.user_fullname;
          //store the user roles in sessionStorage
          const rolesJSON = JSON.stringify(data.connected_user.roles);
          sessionStorage.setItem("userRoles", rolesJSON);
          if(localStorage.getItem("pk")!=null && localStorage.getItem("pk")!=undefined){
            var pk:any = sessionStorage.getItem("pk")?.split(/[\s-]+/)
            //var original_pk=pk.pop();
            pk = pk?.join("-");
            //const last = pk[pk?.length - 1]
            if(pk==="b3ac1552-c4b5-11ed-b4dd-00163ee67c31"){
              this.myPack = "Sur mesure";
            }else {
              this.myPack = "Basique";
            }
          }else {            
            this.myPack = "Basique";
          }
          if(sessionStorage.getItem("pk")!=null && sessionStorage.getItem("pk")!=undefined){
            var pk:any = sessionStorage.getItem("pk")?.split(/[\s-]+/)
            var original_pk=pk.pop();
            pk = pk.join("-");
            if(pk==="b3ac1552-c4b5-11ed-b4dd-00163ee67c31"){
              this.myPack = "Sur mesure";
            }else {
              this.myPack = "Basique";
            }
          }else {            
            this.myPack = "Basique";
          }
          // this.roleconnected = data.connected_user.user_role;

          // if(data.connected_user.user_role=="981dc265-63b8-45ba-b356-befb5a9a6f74"){
          //   this.roleconnected = "DIRECTEUR";
          // }else{
          //   this.roleconnected = "COMMERCIAL";
          // }
          switch (data.connected_user.user_role) {
            case "a21aab19-d73e-47db-a61c-d2c1f0c8a251":
              this.roleconnected = "COMMERCIAL";
              break;
            case "d8aeff31-284b-11ed-8482-00163ee67c31":
              this.roleconnected = "ASSISTANT(E) COMMERCIAL(E)";
              break;
            case "981dc265-63b8-45ba-b356-befb5a9a6f74":
              this.roleconnected = "DIRECTEUR";
              break;
            case "96e04ad6-1ff3-11ee-be56-0242ac120002":
              this.roleconnected = "MF Admin";
              break;
            default:
              this.roleconnected = data.connected_user.user_profile.replaceAll('_',' ');
              break;
          }
        }
      },
    )                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
  }
  formatSentAt(sentAt: string): string {
    const date = new Date(sentAt);
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  }  
  terminatedlistvisits:any[]=[];
  notifCommentsToReply:any[]=[];
  existImportantComment:boolean=false;
  getVisitsToReplyNotif() {
    this.messageService.getLastMessages();
    
    this.messageService.getLastMessagesSubject.subscribe(
      (data: any) => {
        if (data.status === "200") {
          data.lastMessages.forEach((notif : any) => {
            notif.lastCommentAt = this.formatSentAt(notif.sent_at);
            notif.visit_last_comment = notif.message;
            
            this.setCommercialData(notif);
            this.setVisitData(notif);
            this.setCustomerData(notif);
            
            if (notif.is_important) {
              this.existImportantComment = true;
            }
          });
          this.notifCommentsToReply = data.lastMessages;          
        }
      }
    );
  }
  
  private setCommercialData(notif: any) {
    const commercialId = notif.commercial_uuid;
    
    this.userServiceService.getUserFilteredData(commercialId, ['fullName', 'avatar']).subscribe(
      (userData: any) => {
        if (userData) {
          notif.commercial_fullname = userData.connected_user?.user_fullname;
          notif.commercial_avatar = userData.connected_user?.user_avatar;
        }
      },
      (error: any) => {
        console.error('Error fetching user data:', error);
      }
    );
  }
  
  private setVisitData(notif: any) {
    if (notif.visit) {
      this.visitService.getCustomerByVisit(notif.visit, ['id', 'customer', 'logo']);
      
      this.visitService.detailSubject.subscribe(
        (data: any) => {
          if (data.code === "9ee6b80261f5935fcdc9848ac558b605") {
            notif.visit_customer = data.visit.visit_customer;
          }
        }
      );
    }
  }
  
  private setCustomerData(notif: any) {
    if (notif.customer) {
      this.customersService.retrieveCustomer(notif.customer, 'customerRS').subscribe(
        (data: any) => {
          if (data.code === "91cb649c3775dae97f5a003ced0791b9") {
            notif.customer = data.customer.customer_rs;
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }
  
   // this.dashboardServiceservice.getNotifCommentslist();
    // this.dashboardServiceservice.notifCommentslistSubject.subscribe(
    //   ( data: any ) => {        
    //     if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
    //       for(let notif of data.notifications){
    //         if(notif.is_important){
    //           this.existImportantComment = true;
    //         }
    //       }
    //       this.notifCommentsToReply = data.notifications.sort((a:any, b:any) => (a.lastCommentAt > b.lastCommentAt ? -1 : 1));;
    //     }
    // })
  roles: string[]=[]; // Replace with the roles you have
  // Define the required roles for each navigation element with type assertion
  // Define the required roles for each navigation element
  requiredRoles: { [key: string]: string[] } = {
    dashboard: ['MENU_DASH'],
    visites: ['MENU_VISITES'],
    actions: ['MENU_ACTIONS'],
    clients: ['MENU_CLIENTS'],
    team: ['MENU_TEAMS'],
    users: ['MENU_USERS'],
    statistics: ['MENU_STATS'],
    ref: ['MENU_REF'],
    conf: ['MENU_CONF'],
    satisfaction: ['DASH_CONSULTATION_ENQUETES'],
  };
  // Function to check if the user has any of the required roles
  hasRole(navItem: string): boolean {
    const requiredRoles = this.requiredRoles[navItem];
    if (!requiredRoles) {
      return false; // No specific role required for this navigation element
    }

    if (!this.connectedUser?.roles) {
      return false; // User has no roles, so they can't access the navigation element
    }

    const userRoles = this.connectedUser.roles.map((r: any) => r.toLowerCase());
    
    // Check if the user has at least one of the required roles
    return requiredRoles.some(role => userRoles.some((userRole: any) => userRole.includes(role.toLowerCase())));
  }
  MarkAsRead(visit:any, customer: any){
    
    this.dashboardServiceservice.markAsRead(visit, customer);
    this.dashboardServiceservice.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  }
}
